import { initializeApp, getApps } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase yapılandırması
const firebaseConfig = {
  apiKey: "AIzaSyDR2F3PakYJEJo9uqmO9cb367o6X19Epvc",
  authDomain: "aractakip-e606b.firebaseapp.com",
  projectId: "aractakip-e606b",
  storageBucket: "aractakip-e606b",
  messagingSenderId: "327024604844",
  appId: "1:327024604844:web:2cf233c4e8d508bbdf1109"
};

// Uygulama başlatılıyor
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Auth, Firestore ve Storage bağlantıları
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app, "gs://aractakip-e606b");


// ✅ Yeni kullanıcı oluşturma
export const createNewUser = async (email, password, role) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    // Rol Firestore'da kullanıcıya atanabilir (tercihe bağlı)
    return { success: true, user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// ✅ Kullanıcıyı pasifleştirme (Firestore'da "active: false" yapılır)
export const deactivateUser = async (email) => {
  try {
    const q = query(collection(db, "users"), where("email", "==", email));
    const snapshot = await getDocs(q);
    if (snapshot.empty) return { success: false, error: "Kullanıcı bulunamadı" };

    const userDoc = snapshot.docs[0];
    await updateDoc(userDoc.ref, { active: false });
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
};
